module.exports = __webpack_public_path__ + "img/logo-pedade-rodape.50f97f5f.svg";